import { render } from "./documento.vue?vue&type=template&id=722e8f1f"
import script from "./documento.vue?vue&type=script&lang=js"
export * from "./documento.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__